import {TypedUseSelectorHook, useDispatch, useSelector} from "react-redux";
import {AppDispatch} from "../index";
import {RootState} from "../entity/index.entity";
import {useEffect, useState} from "react";

export const useAppDispatch: () => AppDispatch = useDispatch

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export const checkResponse = async (res: Response) => {
    if (!res.ok) {
        throw new Error(`Ошибка ${res.status}`);
    }
    return res.json();
};

export const useMobile = () => { // кастомный хук
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 640);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 640);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return isMobile;
};
